const typeStyles = {
  error: "bg-[#ffdcc5] font-extralight` text-black-800",
  success: "bg-[#DDFFCC] border-green-400 text-black-800",
  warning: "bg-[#FFD1D1] border-yellow-400 text-black ",
  info: "bg-[#CCDDFF] border-blue-400 text-blue-800",
}

export default function StatusBox({ type = "info", title, message, bordered = false }) {
  const baseClasses = "w-full p-6 rounded-xl mb-6 text-center"
  const borderClasses = bordered ? "border-2" : ""
  const colorClasses = typeStyles[type] || typeStyles.info

  return (
    <div className={`${baseClasses} ${borderClasses} ${colorClasses}`}>
      {title && <h3 className="text-xl font-semibold mb-2">{title}</h3>}
      {message && <p>{message}</p>}
    </div>
  )
}
